import IgniteUkLogo from '../../assets/img/ignite_logo_black.png';

import './styles.css';

const Maintenance = () => (
  <div className="maintenance-page">
    <img src={IgniteUkLogo} className="maintenance-page-logo" />
    <h1>Maintenance</h1>
    <p>The Ignite website is currently unavailable while we perform some routine system upgrades.</p>
    <p>Please check back shortly</p>
  </div>
);

export default Maintenance;
